import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import url from "../../function/url";
import EmployeeNavbar from "../Employees/EmployeeNavbar";
import "../company/formstyle.css";
import './JobStreamChangeForm.css';
import Swal from "sweetalert2";

const AddCertificate = () => {
  const [certificateType, setCertificateType] = useState("");
  const [issuer, setIssuer] = useState("");
  const [file, setFile] = useState(null);

  // Assuming the login_id is stored in localStorage or a cookie after login
  const loginId = Cookies.get("log_id");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!certificateType || !issuer || !file) {
      alert("All fields are required.");
      return;
    }
const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    const formData = new FormData();
    formData.append("certificate_type", certificateType);
    formData.append("issuer", issuer);
    formData.append("certificate_file", file);
    formData.append("login_id", loginId); // Pass the login_id to the backend

    axios
      .post(`${url.path}/add-certificate/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRFToken": Cookies.get("csrftoken"), // Include CSRF token if needed
        },
      })
      .then((response) => {
        Toast.fire({
          icon: "success",
          title: "Certificate added successfully!",
        });
        // alert(response.data.success || "Certificate added successfully!");
        // Clear the form
        setCertificateType("");
        setIssuer("");
        setFile(null);
      })
      .catch((error) => {
        console.error("Error adding certificate:", error);
        const errorMessage = error.response?.data?.error || "Failed to add certificate.";
        Toast.fire({
          icon: "error",
          title: "Failed to add certificate.",
        });
        // alert(errorMessage);
      });
  };

  return (
    <>
      <EmployeeNavbar />
      <div className="page-wrapper">
      <div className="form-container">
        <h2 style={{ fontSize: "30px" }}>Add Certificate</h2>
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="certificateType">Certificate Type:</label>
            <input
              id="certificateType"
              type="text"
              value={certificateType}
              onChange={(e) => setCertificateType(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="issuer">Issuer:</label>
            <input
              id="issuer"
              type="text"
              value={issuer}
              onChange={(e) => setIssuer(e.target.value)}
              required
            />
          </div>
          <div className="file-upload">
            <label htmlFor="fileUpload">Upload Certificate (PDF only):</label>
            <input
              id="fileUpload"
              type="file"
              onChange={handleFileChange}
              accept=".pdf" // Restrict to PDF files
              required
            />
          </div>
          <center>
          <button 
           style={{
            width: "150px",
            height: "40px",
            borderRadius: "10px",
            color: "black",
            backgroundColor: "gainsboro",
          }} type="submit">Submit</button>
          </center>

        </form>
      </div>
      </div>
      
    </>
  );
};

export default AddCertificate;
